export default "__VITE_PUBLIC_ASSET__3cbcd0d1__"